<template>
  <div class="commonAgreement-container">
    <div>
      <div>
        <div class="agreement-h1">“规范人人行”</div>
        <div class="agreement-h1">项目劳务协议书</div>
        <CommonHeader :doctorInfo="doctorInfo"></CommonHeader>
        <div style="margin: 10px 0">
          尊敬的
          <span class="agreement-underline-span">{{
            doctorInfo.name || "xxx"
          }}</span
          >：
        </div>
        <div class="agreement-abstract">
          我们很高兴您能参加“规范人人行”项目。本协议在双方友好协商基础上签署，并履行各自义务。一经签署并寄回本协议，视为您和北京利泽慈善基金会就本协议下述约定条款达成一致：
        </div>

        <div class="agreement-h3">一、责任及义务</div>
        <p class="agreement-content-row">
          （一）您将在上述项目中履行如下工作：与本项目相关的
          <i class="iconfont icon-frame" /> 主持
          <i class="iconfont icon-frame" /> 主席
          <i class="iconfont icon-check" />
          授课<i class="iconfont icon-check" />讨论工作。
        </p>
        <p class="agreement-content-row">
          （二）您之所以被邀请提供本协议项目下专业服务是因为您在相关主题上的专长，并确保不带有任何的商业目的。
        </p>
        <p class="agreement-content-row">
          （三）参加本协议上述的活动并提供约定的服务，并未附加任何影响公平竞争的条件，也未与任何商品/服务的购销挂钩。
        </p>
        <p class="agreement-content-row">
          （四）根据您所在国家的适用法律和法规（下称“法律”），您被允许接受上述酬金并出席活动。如果您的雇主和/或您的劳动协议和/或主管机关要求您参加此类活动需要先行通知他们并获得相应的批准，则在活动开始前，您应已经获得出席活动的批准。
        </p>
        <p class="agreement-content-row">
          （五）北京利泽慈善基金会或其技术服务商可以以音频、视频、文字、照片等多种形式录制、记录您在审核中标注的评语及评分用于存档，并在法律规定范围内使用。
        </p>
        <p class="agreement-content-row">
          （六）为了符合国家法律和法规要求，您将提供身份证复印件给予基金会备案及代缴纳税款使用。
        </p>
      </div>
      <div>
        <div class="agreement-h3">二、劳务费与发放</div>
        <p class="agreement-content-row">
          （一）北京利泽慈善基金会将向您提供劳务，税后金额¥<span
            class="agreement-underline-div"
            >{{ doctorInfo.money }}</span
          >（大写人民币：
          <span class="agreement-underline-div">{{
            this.$tools.intToChineseMo(doctorInfo.money)
          }}</span
          >，作为您提供专业服务的报酬，您同意基金会代您向国家税务部门缴纳该笔劳务所得报酬的税费。各方同意，该报酬对于您在本协议项下履行的工作而言是合理且适当的。北京利泽慈善基金会将在您完成约定服务后
          60日内通过银行汇款形式完成付款。
        </p>
      </div>
      <p class="agreement-content-row">（二）银行账号信息</p>
      <!-- <div class="agreement-underline-div">
        姓名：<span>{{ doctorInfo.name }}</span>
      </div>
      <div class="agreement-underline-div">
        联系方式：<span>{{ doctorInfo.phone }}</span>
      </div> -->
      <div class="agreement-underline-div">
        身份证号码：<span>{{ doctorInfo.id_card_number }}</span>
      </div>
      <div class="agreement-underline-div">
        开户行名称：<span>{{ doctorInfo.bank_name_point }}</span>
      </div>
      <div class="agreement-underline-div">
        银行账号（适用存折）：<span>{{ doctorInfo.bank_number }}</span>
      </div>

      <div>
        <div class="agreement-h3">三、保密条款</div>
        <p class="agreement-content-row">
          （一）您确认您持有，且在本协议有效期内都将持有安全、妥善及合法履行本协议规定的服务所需的执照、批文及证书。您陈述并保证，签署本协议以及提供本协议规定的服务在目前和未来均不会造成您违反您受雇的任何机构或实体的任何政策或程序。您确认并同意，包括但不限于与项目商业、财务员工等相关的信息、财产或材料及其任何派生物、部分或复本，在本协议期间或期满或提前终止后五（5）年内承担严格保密义务，
        </p>
        <p class="agreement-content-row">
          （二）您不得为任何目的使用该保密信息，或直接/间接向任何人披露、公布、传播任何保密信息。
        </p>
        <p class="agreement-content-row">
          （三）您同意如果相关政府部门（包括税务部门）要求项目组提供本协议及您的相关个人信息（如身份证复印件或身份证号等）时项目组可以予以提供。如果您不向项目组提供上述个人相关信息，项目组有权不向您支付本协议约定的费用。
        </p>
      </div>

      <div>
        <div class="agreement-h3">四、其他</div>
        <p class="agreement-content-row">
          (一）本协议签订后，未经基金会事先书面同意，您不得转让本协议项下的权利义务。
        </p>
        <p class="agreement-content-row">
          （二）本协议受中华人民共和国法律制约，任何一方未经另一方书面同意不得擅自变更协议条款，对本协议的任何变更项以书面方式进行，并经您和项目组授权代表签字确认。
        </p>
        <p class="agreement-content-row">
          （三）本协议一式两份，双方各执一份，具有同等法律效力。
        </p>
        <p class="agreement-content-row">（以下无正文）</p>
      </div>
    </div>
    <div class="agreement-sign-info">
      <div class="agreemtn-sign-them">
        <div class="agreement-sign-name">
          <span> <!-- 甲方： --> </span>{{ doctorInfo.agreement_company_name }}
        </div>
        <div class="agreement-sign-date">
          日期：{{ $tools.getDate(data.sign_time, "yyyy年MM月dd日") }}
        </div>
      </div>
      <div class="agreemtn-sign-owner">
        <div class="agreement-sign-name">
          <span ref="signDataOne">签署人（姓名）：</span>
          <img
            :src="signInfo.data[0]"
            @click="doSignName(0)"
            v-if="signInfo.data[0]"
            alt=""
          />
          <CustomButton
            class="agreement-sign-button"
            size="small"
            @click="doSignName(0)"
            v-else-if="!signInfo.data[0] && isCanSign"
          >
            <div>
              <span>签名</span>
            </div>
          </CustomButton>
        </div>
        <div class="agreement-sign-date">
          日期：{{ $tools.getDate(doctorInfo.sign_time, "yyyy年MM月dd日") }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CustomButton from "@/components/unit/CustomButton";
import { CircleCheck } from "@element-plus/icons";
import "../../../../assets/icon/iconfont.css";
import CommonHeader from "../header/commonHeader";
export default {
  name: "common-info",
  props: {
    signInfo: {
      type: Object,
      default: {},
    },
    doctorInfo: {
      type: Object,
      default: {},
    },
    isCanSign: {
      type: Boolean,
      default: false,
    },
    meetInfo: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      data: {},
    };
  },
  components: {
    CustomButton,
    CommonHeader,
    CircleCheck,
  },
  methods: {
    verifyData() {
      if (!this.signInfo.data[0]) {
        console.log(this.$refs.signDataOne);
        let height = this.$refs.signDataOne.offsetTop;
        this.$emit("doScroll", height);
        this.$tips.error({ text: "请签署协议后再提交" });
        // this.$tips.error({ text: "请先签署第一个签名" });
        return false;
      }
      // if (!this.signInfo.data[1]) {
      //   let height = this.$refs.signDataTwo.offsetTop;
      //   this.$emit("doScroll", height);
      //   this.$tips.error({ text: "请先签署第二个签名" });
      //   return false;
      // }
      return true;
    },
    doSignName(index) {
      if (!this.isCanSign) return;
      this.$emit("doSignName", index);
    },
  },
};
</script>
<style>
.agreement-sign-button {
  width: 64px !important;
  font-size: 13px;
}
.agreement-td:last-child {
  border-right: 0;
}
.agreement-row:last-child > .agreement-td {
  border-bottom: 0;
}
.agreement-h1-second {
  margin-top: 30px;
}
</style>